import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const TomorrowLinechart = ({ chartdata, displaychart }) => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  const { value } = displaychart || {};
  const genderValue = value === "0" ? "both" : Number(value);
  useEffect(() => {
    if (!chartdata || chartdata.length === 0) return;
    const years = chartdata.map((d) => d.year || "");
    const projectionYear = Number(sessionStorage.getItem("projection_year"));

    // Helper to split data into actual and projected segments
    const splitData = (dataKey) => {
      const actualData = chartdata.map((d) => {
        const year = Number(d.year);
        return year <= projectionYear ? d[dataKey] ?? null : null;
      });

      const projectedData = chartdata.map((d) => {
        const year = Number(d.year);
        return year >= projectionYear ? d[dataKey] ?? null : null;
      });

      return { actualData, projectedData };
    };

    let series = [];
    let colors = [];
    let dashArray = [];

    // Standard ApexCharts colors
    const colorMale = "#008FFB";
    const colorFemale = "#00E396";

    switch (genderValue) {
      case 1: // Male
        const maleSplit = splitData("projected_male_cases");
        series = [
          { name: "Male Cases", data: maleSplit.actualData },
          { name: "Male Projection", data: maleSplit.projectedData }
        ];
        colors = [colorMale, colorMale];
        dashArray = [0, 5];
        break;

      case 2: // Female
        const femaleSplit = splitData("projected_female_cases");
        series = [
          { name: "Female Cases", data: femaleSplit.actualData },
          { name: "Female Projection", data: femaleSplit.projectedData }
        ];
        colors = [colorFemale, colorFemale];
        dashArray = [0, 5];
        break;

      case "both":
      default:
        const mSplit = splitData("projected_male_cases");
        const fSplit = splitData("projected_female_cases");
        series = [
          { name: "Male Cases", data: mSplit.actualData },
          { name: "Male Projection", data: mSplit.projectedData },
          { name: "Female Cases", data: fSplit.actualData },
          { name: "Female Projection", data: fSplit.projectedData }
        ];
        colors = [colorMale, colorMale, colorFemale, colorFemale];
        dashArray = [0, 5, 0, 5];
        break;
    }

    setChartSeries(series);

    setChartOptions({
      markers: {
        size: 4,
      },
      chart: {
        type: "line",
      },
      stroke: {
        curve: "smooth",
        dashArray: dashArray
      },
      colors: colors,
      xaxis: {
        categories: years,
        title: { text: "Year" },
      },
      yaxis: {
        title: { text: "Cases" },
      },
      dataLabels: { enabled: false },
      legend: { position: "top" },
      tooltip: {
        y: {
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            // Check if this is a projected series (odd index)
            const isProjected = seriesIndex % 2 !== 0;

            if (isProjected) {
              // The corresponding actual series is always the previous one (even index)
              const actualSeriesIndex = seriesIndex - 1;
              const actualValue = w.globals.series[actualSeriesIndex][dataPointIndex];

              // This handles the overlap point (e.g., 2020) where both exist
              if (actualValue !== null && actualValue !== undefined) {
                return undefined;
              }
            }
            return val;
          }
        }
      }
    });
  }, [chartdata, genderValue]);

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={400}
        width="100%"
      />
    </div>
  );
};

export default TomorrowLinechart;
